(() => {
  if (window.kgTextControlsBooted) return;
  window.kgTextControlsBooted = true;
  const observers = new WeakMap();
  const apply = (root = document) => {
    root.querySelectorAll('[data-kg-text-controls]').forEach(config => {
      const section = config.closest('[id^="shopify-section-"]');
      if (!section) return;
      let state = observers.get(section);
      if (!state) {
        state = {timer: null, observer: new MutationObserver(() => {
          clearTimeout(state.timer);
          state.timer = setTimeout(() => apply(section), 80);
        })};
        observers.set(section, state);
      }
      state.observer.disconnect();
      section.querySelectorAll('[data-kg-text-accent]').forEach(span => span.replaceWith(...span.childNodes));
      const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,[hidden],svg,option,[aria-hidden="true"]')) return;
        const kind = parent.closest('h1,h2,h3,h4,h5,h6,.product-title,.kg-sticky-purchase__title') ? 'heading'
          : parent.closest('button,.btn,.kgsh-button') ? 'button'
          : parent.closest('label,nav,.footer-menus,.price,.product-price,.item-price,.item-price-old,.item-unit-price,.swatch-variant-option-name,.variant-title,.kg-sticky-purchase__price,[data-sticky-variant]') ? 'label' : 'body';
        const phrase = config.dataset[kind + 'Phrase']?.trim();
        const color = config.dataset[kind + 'Color'];
        if (!phrase || !color || !node.textContent.includes(phrase)) return;
        // Existing Liquid spans already hold a chosen second color.
        if (parent.closest('span[style*="color"],[data-kg-text-accent]')) return;
        const pieces = node.textContent.split(phrase);
        const fragment = document.createDocumentFragment();
        pieces.forEach((piece, index) => {
          if (index) {
            const span = document.createElement('span');
            span.dataset.kgTextAccent = '';
            span.style.setProperty('color', color, 'important');
            span.textContent = phrase;
            fragment.append(span);
          }
          fragment.append(document.createTextNode(piece));
        });
        node.replaceWith(fragment);
      });
      state.observer.observe(section, {childList:true,subtree:true,characterData:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply());
  else apply();
  document.addEventListener('shopify:section:load', event => apply(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const state = observers.get(event.target);
    if (state) {state.observer.disconnect(); clearTimeout(state.timer);}
  });
})();
